export enum EPaymentTransactionStatus {
    UNKNOWN,
    PENDING,
    COMPLETED
}
export class PaymentTransaction {
    id: string;
    orderId: string;
    url: string;
    status: EPaymentTransactionStatus;
    constructor(other?: Partial<PaymentTransaction>) {
        this.id = other?.id || '';
        this.orderId = other?.orderId || '';
        this.url = other?.url || '';
        this.status = other?.status || EPaymentTransactionStatus.UNKNOWN;
    }

    static fromResponse(res: any): PaymentTransaction {
        return new PaymentTransaction({
            id: res.id,
            orderId: res.orderId,
            url: res.url,
            status: res.status
        })
    }
}